import React, { useEffect, useMemo } from "react";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import { actions as modalActions } from "@/bit/reducers/next13.reducers.modals-reducer";
import { actions as mainActions } from "@/bit/reducers/next13.reducers.main-reducer";
import getDeviceKindDependsOnViewPort from "@gerenciatd/next13.utils.common.get-device-kind-depends-on-viewport";
import { whichAnimationEvent } from "./utils";
import PriceModule from "./price-module";
import ActionCallModule from "./action-call-module";
import LegalModule from "./legal-module";
import C2CModule from "./c2c-module";

function BuyBox(props) {
  const dispatch = useDispatch();
  const { zone, cpModalClosed, refreshZone, logged } = useSelector(
    (state) => state.main
  );

  const product = useMemo(
    () =>
      props["Product-2"] && zone === "ZR"
        ? props["Product-2"]
        : props["Product-1"],
    [zone && cpModalClosed]
  );

  const skeletonClassName = zone || !props["Product-2"] ? "noanimated" : "";

  const buttonHref = product["Button-1"]?.href
    ? product["Button-1"]?.href
    : logged
    ? product["Button-1"].urlLinkclient
    : product["Button-1"].urlLinknoclient;

  const showModalLegalHandler = () => {
    const LegalModal = dynamic(() => import("./modals/legal"));

    dispatch(
      modalActions.addModal({
        id: "legal-modal",
        Element2Show: LegalModal,
        modalProps: {
          closeIdByClickingOutside: "closeAll",
          contentPosition: "right--top",
          opacityLayoutColor: "blur",
          inSceneEffect: "fadeIn",
          contentInsideContainer: false,
          outSceneEffect: "fadeOut",
          closeByClickingOutside: true,
          scrollAllowed: false,
          createAnchor: false,
        },
        elementProps: {
          title: product["Legal-1"]?.["Text-1"] || "",
          description: product["Legal-1"]?.["Text-2"] || "",
        },
      })
    );
  };

  const changeZoneModalHandler = () => {
    const BuyBoxModal = dynamic(() => import("./modals/zone-change"));
    const device = getDeviceKindDependsOnViewPort();

    dispatch(
      modalActions.addModal({
        id: "cnmc",
        Element2Show: BuyBoxModal,
        modalProps: {
          contentPosition:
            device !== "MOBILE" ? "center--center" : "center--bottom",
          opacityLayoutColor: "blur",
          inSceneEffect: "fadeIn",
          contentInsideContainer: false,
          outSceneEffect: "fadeOut",
          closeByClickingOutside: true,
          scrollAllowed: false,
        },
        elementProps: {},
      })
    );
  };

  const onChangeZone = () => {
    const transitionEvent = whichAnimationEvent();
    const element = document.getElementById("animationReference");

    if (transitionEvent) {
      element.addEventListener(transitionEvent, () => {
        setTimeout(() => {
          changeZoneModalHandler();
        }, 100);
      });
    }
  };

  useEffect(() => {
    if (refreshZone && props["Product-2"]) {
      onChangeZone();
    }

    dispatch(mainActions.setZoneRefreshFlag(false));
  }, [product && refreshZone && cpModalClosed]);

  return (
    <div className="buy-box">
      <div className="buy-box-content">
        <PriceModule
          prePriceText={product["Text-0"]}
          topLabel={product["Label-1"]}
          mainPrice={product["Price-2"]}
          secondaryPrice={product["Price-1"]}
          postPriceText={product["Text-1"]}
          secondaryText={product["Text-2"]}
          skeletonClassName={skeletonClassName}
        />
        <ActionCallModule
          simplePhone={props["simplePhone"]}
          button={{ ...product["Button-1"], href: buttonHref }}
          skeletonClassName={skeletonClassName}
        />
        {props["simplePhone"]?.["Text-3"] && <C2CModule textLink={props["simplePhone"]["Text-3"]}/>}
      </div>
      <LegalModule
        button={product["Button-2"]}
        onClick={showModalLegalHandler}
        text={product["Text-4"]}
        skeletonClassName={skeletonClassName}
      />
    </div>
  );
}

export default BuyBox;
